import styled, { css } from 'styled-components';

export const CheckoutPageFilter = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  
  transition: filter 0.3s;
  
  ${({ status }) => status !== 'initial' && status !== 'hasAccount' && status !== 'failure' && css`
    height: 100vh;
    overflow: hidden;
    
    filter: blur(15px);
    
    user-select: none;
    pointer-events: none;
  `}
`;

export const StatusContainer = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  
  text-align: center;
  
  p {
    margin: 0;
    margin-top: 10px;

    font-weight: 700;
    font-size: 14px;
  
    user-select: none;
    pointer-events: none;
  }
  
  button {
    margin-top: 5px;
    
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.blue};
    
    transition: color 0.3s;
    cursor: pointer;
    
    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }
`;
